import React from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ size = 'md', showText = true, className = '' }) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10', 
    lg: 'w-12 h-12'
  };

  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl'
  };

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      <div className="relative">
        {/* LOGO-A9 */}
        <img 
          src="./images/LOGO-A9.png" 
          alt="ريشة | وكالة تسويق نمو وأداء" 
          className={`${sizeClasses[size]} object-contain icon-soft-glow`}
        />
      </div>
      
      {showText && (
        <div className="flex flex-col">
          <span className={`${textSizeClasses[size]} font-bold text-foreground leading-none arabic-heading`}>
            ريشة
          </span>
          {size !== 'sm' && (
            <span className="text-xs text-muted-foreground font-medium tracking-wide arabic-text">
              وكالة تسويق نمو وأداء
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default Logo;